<a
  class="fare_rules_link"
  (click)="getCarDetails(car)"
  (keydown.enter)="getCarDetails(car)"
  tabindex="0"
  role="button"
  aria-label="Car details"
  i18n-aria-label
>
  <i class="currency_info_icon" aria-hidden="true"></i>
</a>
